<template>
    <div class="form-group">
        <input 
            type="search"
            ref="search"
            class="form-control mb-1"
            v-model="search"
            v-debounce:2s="focusSelect"
            placeholder="Search..."
        >
        <select
            :disabled="search === ''"
            class="form-control"
            ref="dropdown"
            @change="emitInput"
        >
            <option value="">
                Select...
            </option>
            <option 
                v-for="product in filteredProducts"
                :key="product.id"
                :value="product.id"
            >
                {{ product.name }} - {{ product.code }}
            </option>
        </select>
    </div>
</template>
<script>
import ProductService from '../services/ProductsService';

export default {
    props: {
        value: {
            default: null,
            type: [String, Number, Object],
        },
        customerId: {
            default: null,
            type: [String, Number],
        },
    },
    data() {
        return {
            search: '',
            products: [],
        }
    },
    computed: {
        filteredProducts() {
            const search = this.search;
            if (!search) {
                return [];
            }
            return this.products.filter(product => {
                if (product.name && product.name.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
                if (product.code && product.code.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                if (!this.value) {
                    this.search = '';
                    return;
                }
                this.search = this.value.name;
            }
        },
        customerId: function () {
            this.loadProducts();
        },
    },
    created() {
        this.loadProducts();
        this.$refs.search.focus();
    },
    methods: {
        loadProducts() {
            ProductService.index({ customer_id: this.customerId }).then(({data}) => {
                this.products = data;
            });
        },
        focusSelect() {
            if(this.filteredProducts.length === 0) {
                return;
            }
            this.$refs.dropdown.focus();
        },
        emitInput(event) {
            let value = event.target.value;
            value = this.products.find(p => p.id === parseInt(value));
            
            this.$emit('input', value);
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ProductSearchComponent.vue